module.exports = "/38b7cebf42ef06bc988582414cca0feb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/feature-4-1.png
 ** module id = 2214
 ** module chunks = 0
 **/